// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"375":"19ea6746","453":"66a8ed72","664":"6fa099bf","810":"223ac18e","929":"5bfea1c2","971":"3252bf2f","999":"3890f860"}[chunkId] + ".chunk.js";
};